import React from "react";
import { Link } from "react-router-dom";
import { useDocumentMeta } from "../components/useDocumentMeta";
import { pastEvents, upcomingEvents } from "../content/events";
import EventCard from "../components/EventCard";
import CtaBand from "../components/CtaBand";

function Events() {
  useDocumentMeta(
    "Events",
    "Events and meetups on Platform Engineering and Internal Developer Platforms — with Red Hat, BoldBrave and Logikfabriken.",
  );

  return (
    <>
      <section className="page-hero">
        <div className="container">
          <p className="kicker">Events</p>
          <h1 className="page-title">Where the community meets</h1>
          <p className="page-lead">
            We host and join events on Platform Engineering and Internal
            Developer Platforms — keynotes, live demos and real-world case
            studies, with time to talk to the people who build this for a living.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-head">
            <p className="kicker">Upcoming</p>
            <h2 className="section-title">Coming up</h2>
          </div>
          {upcomingEvents.length ? (
            <div className="event-list">
              {upcomingEvents.map((event) => (
                <EventCard key={event.slug} event={event} />
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <p>
                No events scheduled right now — new dates are announced here.
                Want an invite?{" "}
                <Link to="/contact" className="inline-link">
                  Let us know
                </Link>
                .
              </p>
            </div>
          )}
        </div>
      </section>

      {pastEvents.length ? (
        <section className="section section-alt">
          <div className="container">
            <div className="section-head">
              <p className="kicker">Looking back</p>
              <h2 className="section-title">Past events</h2>
            </div>
            <div className="event-list">
              {pastEvents.map((event) => (
                <EventCard key={event.slug} event={event} />
              ))}
            </div>
          </div>
        </section>
      ) : null}

      <CtaBand
        title="Want to talk platforms in person?"
        text="We're often out at meetups and happy to meet — or to bring the conversation to your team."
        to="/contact"
        label="Talk to us"
      />
    </>
  );
}

export default Events;
